export class AdminUserSelectItem {
  id: number;
  name: string = "";
  username: string = "";

  constructor(id: number, init?: Partial<AdminUserSelectItem>) {
    if (init) Object.assign(this, init);
    this.id = id;
  }
}